
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = "https://kfzafaxoxryyppjvvjlh.supabase.co";
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtmemFmYXhveHJ5eXBwanZ2amxoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDgxNzQ4NDIsImV4cCI6MjA2Mzc1MDg0Mn0.sdRtvax8PBoDQtUK9h57qRmMkUC3W3-8sPbYgg4yTSM";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
